import React, {useRef} from 'react';
import styled from "styled-components";
import FolderAddSvg from "assets/folder-add.svg";

export const FiltersModal: React.FC<{setIsOpen: (b: boolean) => void}> = ({setIsOpen}) => {

    return (
        <Overlay onClick={() => setIsOpen(false)}>
            <ModalContainer onClick={(e) => e.stopPropagation()}>
                <Content>
                    <FiltersContainer>
                        <Caption>Filters</Caption>
                        <SaveFilter>
                            <FolderAdd />
                            <Text>Save current filters</Text>
                        </SaveFilter>
                    </FiltersContainer>
                    <FiltersContainer>
                        <Caption>Saved filters</Caption>
                        <Text>No saved filters yet</Text>
                    </FiltersContainer>
                </Content>
            </ModalContainer>
        </Overlay>)
};

const Overlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: transparent;
    z-index: 1000;
`;

const ModalContainer = styled.div`
    position: absolute;
    top: 13rem;
    right: 4rem;
    background: white;
    border-radius: 8px;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
    z-index: 1001;
    min-width: 200px;
    display: flex;
    align-items: center;

    @media (max-width: 768px) {
        top: 5.6rem;
        right: 3rem;
    }
`;

const Content = styled.div`
    position: relative;
    font-family: SF Pro Display;
    display: flex;
    flex-direction: column;
    gap: 20px;
    padding: 18px 18px 20px;
`;

const FiltersContainer = styled.div`
    display: flex;
    align-items: start;
    flex-direction: column;
    gap: 15px;
`;

const Caption = styled.div`
    font-size: 15px;
    font-weight: 600;
    color: #000000;
`;

const Text = styled.div`
    font-size: 13px;
    font-weight: 500;
    color: #00000080;
`;

const FolderAdd = styled(FolderAddSvg)`
  width: 20px;
  height: 20px;
`;

const SaveFilter = styled.div`
  display: flex;
  align-items: center;
  gap: 4px; 
  cursor: pointer;
    
    &:hover {
        div {
            color: #00000095;
        }
        path {
            fill: #00000090;
        }
    }
`;